module.exports = __webpack_public_path__ + "img/no-gps-heading.2f514268.svg";